(function () {
  let postsSwiper;

  const initSlider = (slider) => {

    if (slider.classList.contains('swiper-initialized')) return;

    slider.classList.add("swiper");

    const wrapper = slider.querySelector(".blog-posts-grid");
    if (!wrapper) return;

    wrapper.classList.add("swiper-wrapper");

    const slides = slider.querySelectorAll(".blog-posts-card");
    if (!slides || !slides.length) return;

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const nextBtn = slider.querySelector(".blog-posts-nav-button--next") || 
                   slider.querySelector(".products-tabs__navigation-button-next");
    const prevBtn = slider.querySelector(".blog-posts-nav-button--prev") || 
                   slider.querySelector(".products-tabs__navigation-button-prev");

    const isVisibleOverflow = slider.classList.contains("swiper--blog-posts--visible-overflow");
    const spaceBetween = isVisibleOverflow ? 16 : 20;
    
    let slidesPerView = isVisibleOverflow ? "auto" : 1.3;
    let centeredSlides = false;
    let slidesOffsetBefore = 0;
    let slidesOffsetAfter = 0;

    if (isVisibleOverflow) {
      centeredSlides = false;
      slidesOffsetBefore = 24;
      slidesOffsetAfter = 24;
    }

    const swiperOptions = {
      loop: false,
      slidesPerView: slidesPerView,
      spaceBetween: spaceBetween,
      speed: 400,
      centeredSlides: centeredSlides,
      slidesOffsetBefore: slidesOffsetBefore,
      slidesOffsetAfter: slidesOffsetAfter,
      breakpoints: {
        
        576: { 
          slidesPerView: isVisibleOverflow ? 1.5 : 2,
          spaceBetween: 20,
          centeredSlides: false,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        768: {
          slidesPerView: isVisibleOverflow ? 2.5 : 3,
          spaceBetween: 24
        },
        992: { 
          slidesPerView: isVisibleOverflow ? 3.5 : 4,
          spaceBetween: 24
        },
        1200: {
          slidesPerView: isVisibleOverflow ? 4.5 : 4,
          spaceBetween: 16
        }
      }
    };

    if (nextBtn && prevBtn) {
      swiperOptions.navigation = {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "blog-posts-nav-button--disabled",
      };
    }

    const scrollbar = slider.querySelector(".swiper-scrollbar");
    if (scrollbar) {
      swiperOptions.scrollbar = {
        el: scrollbar,
        draggable: true,
        snapOnRelease: true
      };
    }

    postsSwiper = new Swiper(slider, swiperOptions);
    
    const images = slider.querySelectorAll('img');
    if (images.length) {
      images.forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', () => postsSwiper.update());
        }
      });
    }
  };

  const destroySlider = (section) => {
    if (!section || !section.classList.contains("blog-posts")) return;

    const slider = section.querySelector(".blog-posts-container.swiper");
    if (!slider) return;

    const slides = section.querySelectorAll(".blog-posts-card.swiper-slide");
    const wrapper = section.querySelector(".blog-posts-grid.swiper-wrapper");

    if (postsSwiper) {
      postsSwiper.destroy(true, true);
      postsSwiper = null;
    }

    if (slider) slider.classList.remove("swiper");
    if (wrapper) wrapper.classList.remove("swiper-wrapper");
    if (slides && slides.length) {
      slides.forEach((slide) => {
        slide.classList.remove("swiper-slide");
        slide.removeAttribute('style');
      });
    }
  };

  const initBlogPosts = (section) => {
    if (!section || !section.classList.contains("blog-posts")) return;

    const slider = section.querySelector(".blog-posts-container");
    if (!slider) return;

    const shouldEnableSlider = slider.classList.contains("swiper--blog-posts") || 
                             window.innerWidth < 992;

    if (shouldEnableSlider) {
      initSlider(slider);
    }

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const width = entry.contentRect.width;
        
        if (width >= 992 && !slider.classList.contains("swiper--blog-posts")) {
          destroySlider(section);
        } 
        else if (width < 992 || slider.classList.contains("swiper--blog-posts")) {
          if (!slider.classList.contains("swiper-initialized")) {
            initSlider(slider);
          } else if (postsSwiper) {
            postsSwiper.update();
          }
        }
      });
    });

    sectionResizeObserver.observe(section);
  };

  const animateBlogPostCards = (section) => {
    if (!section || !section.classList.contains("animate-on-scroll")) return;

    const blogPostsContainer = section.querySelector(".blog-posts-container");
    if (!blogPostsContainer) return;

    ScrollTrigger.matchMedia({
      "(max-width: 575px)": function () {
        ScrollTrigger.create({
          trigger: blogPostsContainer,
          start: "top 90%",
          end: "bottom top",
          onEnter: () => blogPostsContainer.classList.add("animated"),
          markers: false
        });
      },
      "(min-width: 576px) and (max-width: 991px)": function () {
        ScrollTrigger.create({
          trigger: blogPostsContainer,
          start: "top 85%",
          end: "bottom top",
          onEnter: () => blogPostsContainer.classList.add("animated"),
          markers: false
        });
      },
      "(min-width: 992px)": function () {
        ScrollTrigger.create({
          trigger: blogPostsContainer,
          start: "top 80%",
          end: "bottom top",
          onEnter: () => blogPostsContainer.classList.add("animated"),
          markers: false
        });
      }
    });
  };

  // Initialize
  document.addEventListener("DOMContentLoaded", function() {
    const section = document.querySelector(".blog-posts") || document.currentScript.parentElement;
    destroySlider(section);
    initBlogPosts(section);
    animateBlogPostCards(section);
  });

  document.addEventListener("shopify:section:load", function (e) {
    destroySlider(e.target);
    initBlogPosts(e.target);
    animateBlogPostCards(e.target);
  });

  window.addEventListener('resize', function() {
    if (postsSwiper) {
      postsSwiper.update();
    }
  });
})();